// extracted by mini-css-extract-plugin
module.exports = {"homePage":"home_homePage__ujXDM","canvasContainer":"home_canvasContainer__23MDe"};